// removed by extract-text-webpack-plugin
module.exports = {"AllocationDropDown":"AllocationDropDown__AllocationDropDown__6o3q0","allocation-dropdown-slidedown":"AllocationDropDown__allocation-dropdown-slidedown__3b2wx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AllocationDropDown/AllocationDropDown.css
// module id = 494
// module chunks = 0